module.exports = __webpack_public_path__ + "img/sam-nassour-iggy.069fe47.jpg";